import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Payslip',
  meta: {
    icon: 'fa fa-bank',
    expanded: false,
    roles: Global.ALL_ROLE
  },

  children: [
    {
      name: 'Upload Payslip',
      path: '/payslip/PayslipUpload',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('payslip/PayslipUpload')
    },
    {
      name: 'Payslip Manager',
      path: '/payslip/PayslipManager',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('payslip/PayslipManager')
    },
    {
      name: 'My Payslip',
      path: '/payslip/MyPayslip',
      meta: {
        roles: Global.ALL_ROLE
      },
      component: lazyLoading('payslip/MyPayslip')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/payslip.js